import styled from '@emotion/styled';
import { Text } from 'ds/components/typography';

export const Root = styled.div``;

export const DeveloperLinkWrapper = styled.a`
  text-decoration: none;
  color: inherit;
  outline: none;
`;

export const DeveloperWrapper = styled.div<{ hasLink: boolean; hasDescription: boolean; isCommercial?: boolean; }>`
  ${({ theme, isCommercial }) => `
    margin-bottom: ${theme.spacing(3)};
    display: flex;
    align-items: center;
    &:last-of-type {
      ${isCommercial ? '' : 'border-bottom: 0;'}
    }
  `}
  ${({ theme, hasLink }) => theme.media.showAt({ at: 1 }) `
    ${hasLink ? `
      border: none;
    ` : ''}
  `}
`;

export const DeveloperLogo = styled.div`
  ${({ theme }) => `
    margin-${theme.isRTL ? 'left' : 'right'}: ${theme.spacing(3)};
    height: 64px;
    width: 64px;
    border-radius: ${theme.borderRadius.tiny};
    padding: ${theme.spacing(0.5)};
    background: ${theme.colors.neutrals.white};
    box-shadow: ${theme.shadow.level2};
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    img {
      display: block;
      object-fit: contain;
      max-width: 100%;
      height: 100%;
      margin: 0 auto;
    }
  `}
  ${({ theme }) => theme.media.showAt({ at: 1 }) `
    margin-${theme.isRTL ? 'left' : 'right'}: ${theme.spacing(2)};
  `}
`;

export const DeveloperInfo = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-grow: 1;
`;

export const DeveloperMainInfo = styled.div`
  ${({ theme }) => `
    display: flex;
    flex-basis: 100%;
    margin-bottom: ${theme.spacing(0.25)};
  `}
  ${({ theme }) => theme.media.showAt({ at: 1 }) `
    flex-wrap: wrap;
  `}
`;

export const EstablishmentYear = styled(Text)`
  ${({ theme }) => `
    display: inline-flex;
    white-space: nowrap;
    align-items: center;
    margin-${theme.isRTL ? 'right' : 'left'}: ${theme.spacing(1)};
    color: ${theme.colors.neutrals.grey3};
    &:not(:empty):before {
      content: '|';
      margin-${theme.isRTL ? 'left' : 'right'}: ${theme.spacing(1)};
    }
  `}
  ${({ theme }) => theme.media.showAt({ at: 1 }) `
    margin: 0;
    flex-basis: 100%;
    height: 24px;
    &:before {
      display: none;
    }
  `}
`;

export const DeveloperLinks = styled.div`
  display: flex;
  flex-basis: 100%;
  ${({ theme }) => theme.media.showAt({ from: 2 }) `
    div:not(:first-of-type) {
      margin-${theme.isRTL ? 'right' : 'left'}: ${theme.spacing(3)};
    }
  `}
  ${({ theme }) => theme.media.showAt({ at: 3 }) `
    div:not(:first-of-type) {
      margin-${theme.isRTL ? 'right' : 'left'}: ${theme.spacing(1)};
    }
  `}
  ${({ theme }) => theme.media.showAt({ at: 1 }) `
    flex-direction: column;
  `}
  > a {
    color: ${({ theme }) => theme.colors.brand.main};
  }
`;

export const DeveloperLinkInner = styled.div`
  ${({ theme }) => `
    display: flex;
    align-items: center;

    > svg {
      margin-right: ${theme.spacing(0.5)};
    }
  `}
`;
